import { RealtimeHeartbeatWatchdog } from './RealtimeHeartbeatWatchdog';

export type HeartbeatFailure = { reason: 'response_timeout' } | { reason: 'send_failed'; error: unknown };

export interface RealtimeHeartbeatTransport {
  isOpen(): boolean;
  sendPing(): void;
}

/** Owns the application heartbeat timer while the connection owns recovery policy. */
export class RealtimeHeartbeatController {
  private interval: ReturnType<typeof setInterval> | null = null;
  private readonly watchdog: RealtimeHeartbeatWatchdog;

  public constructor(
    private readonly intervalMs: number,
    responseDeadlineMs: number,
    private readonly transport: RealtimeHeartbeatTransport,
    private readonly onFailure: (failure: HeartbeatFailure) => void,
  ) {
    this.watchdog = new RealtimeHeartbeatWatchdog(responseDeadlineMs);
  }

  public start(): void {
    this.stop();
    this.interval = setInterval(() => this.tick(), this.intervalMs);
  }

  public stop(): void {
    if (this.interval) clearInterval(this.interval);
    this.interval = null;
    this.watchdog.reset();
  }

  public recordPong(): void {
    this.watchdog.recordPong();
  }

  private tick(): void {
    if (!this.transport.isOpen()) {
      this.stop();
      return;
    }
    if (!this.watchdog.recordPing()) {
      this.stop();
      this.onFailure({ reason: 'response_timeout' });
      return;
    }
    try {
      this.transport.sendPing();
    } catch (error) {
      this.stop();
      this.onFailure({ reason: 'send_failed', error });
    }
  }
}
